import type { MaybeRef } from "@vueuse/core";
import { Ref, unref } from "vue";

/*
 * @Author: hzm
 * @Date: 2022-11-22 08:11:24
 * @Description: 
 */
export function tansParams(params: { [key in string]: any }) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof value !== "undefined" && value !== "") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof value[key] !== "undefined") {
            const params = propName + "[" + key + "]";
            const subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

export function handleTree(
  data: any,
  id?: string,
  parentId?: string,
  children?: any
): never[] {
  const config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  const childrenListMap: { [key: string]: any } = {};
  const nodeIds: { [key: string]: any } = {};
  const tree: never[] = [];
  for (const d of data) {
    const parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (const d of data) {
    const parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      d.level = 0
      // console.log('d.level: ', d.level);
      tree.push(d);
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o: { [x: string]: any }, level = 0) {
    if (childrenListMap[o[config.id]] !== null) {
      o.level = level;
      o[config.childrenList] = childrenListMap[o[config.id]];
      level++;
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c, level);
      }
    }
  }
  return tree;
}


//  打平树结构
export function flattenTree(tree: any[], childrenKey = "children") {
  const flatten = [];
  for (const item of tree) {
    flatten.push(item);
    if (item[childrenKey]) {
      flatten.push(...flattenTree(item[childrenKey]));
    }
  }
  return flatten;
}


// 验证是否为blob格式
export async function blobValidate(data: { text: () => any }) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}

/**
 * 将zdCloud,indBrain 格式转化 字典 value字段 智电云，产业大脑
 *
 *
 */
/**
 *将zdCloud,indBrain 格式转化 字典 value字段 智电云，产业大脑
 *例 zdCloud,indBrain=>智电云，产业大脑
 * @export
 * @param {string} str
 * @param {DictType[]} dicts
 * @param {string} [delimiter=',']
 * @return {*}
 */
export function formatDictValue(str: string, dicts: DictType[], delimiter = ',') {
  // console.log('str: ', str);

  if (str) {
    const strArr = str.split(delimiter).filter(Boolean);
    const labelArr = dicts
      .map(item => (strArr.includes(item.value as string) ? (item.label as string) : ''))
      .filter(Boolean);
    return labelArr.join('/');
  }
  return '';
}
/**
 *
 * 图片izhi取第一张
 * 例 图片地址1,图片地址2=>图片地址1
 * @export
 * @param {string} str
 * @param {string} [delimiter=',']
 * @return {*}
 */
export function splitStr(str: string, delimiter = ',') {
  if (str) {
    return str.split(delimiter)?.[0] ?? '';
  }
  return '';
}

//
export function findFirstPathFromRoutes(routes: ObjType[]) {
  let fullPath = '';
  if (routes?.[0]) {
    fullPath += routes[0].path;
    if (routes?.[0]?.children?.length) {
      fullPath += '/' + findFirstPathFromRoutes(routes[0].children);
    }
  }
  return fullPath;
}


export const stripEmpty = (arr: any[]) => {
  return arr.filter(
    (o) => o.tag
  );
};

/**
 * @description 处理查询时间
 * @param queryParams 查询参数
 * @param dateRange
 */
export function handleDateRange(queryParams: MaybeRef<any>, dateRange: { [key: string]: string[] }) {
  const unrefData = unref(queryParams);
  for (const key in dateRange) {
    if (Object.prototype.hasOwnProperty.call(dateRange, key)) {
      const item = dateRange[key];

      const firstUpperCase = ([first, ...rest]: string[]) => first?.toUpperCase() + rest.join('');
      const camelCaseKey = firstUpperCase(key.split(''));
      if (!unrefData.params) unrefData.params = {};
      unrefData.params['begin' + camelCaseKey] = item?.length == 2 ? item[0] : undefined;
      unrefData.params['end' + camelCaseKey] = item?.length == 2 ? item[1] : undefined;
    }
  }
}


/**
 * 
 * @param id  查找节点的id
 * @param dataTree 查找的树
 * @param res //返回的结果
 */
export function findNodeParentsPath(id: number, dataTree: {}[],) {
  let rightPath = []

  function getParentsPath(id: number, dataTree: {}[], res: {}[] = []) {
    for (const item of dataTree) {
      res.push(item)
      //
      if (item.id == id) {
        rightPath = JSON.parse(JSON.stringify(res))
        return true;
      }

      if (item.children && item.children.length) {
        const result = getParentsPath(id, item.children, res)
        // console.log('result123: ', result, res);
        if (result)
          return;
      }
      res.pop();
    }
    return false;
  }

  getParentsPath(id, dataTree, [])
  return rightPath;

};


// 转化sku 数据

/**
 * 
 * @param skuData [{"key":"材质","value":"铜板不干胶"},{"key":"规格","value":"65*45 1列 50米 1060张/卷"}] =》 材质:铜板不干胶；规格:65*45 1列 50米 1060张/卷
 * @returns 
 */
export function getSkuData(skuData) {
  try {
    const sku = JSON.parse(skuData);
    // console.log('sku: ', sku);

    return sku.map(item => `${item.key}:${item.value}`);
  } catch {
    return [];
  }
}
